module.exports = __webpack_public_path__ + "img/Modern Maple.d23448f5.jpg";